export const getStatusTagIDs = (status) => (
    [status.Tag1, status.Tag2, status.Tag3]
        .map(value => parseInt(value, 10))
        .filter(value => Number.isInteger(value) && value > 0)
);

export const buildStatusOptions = (statuses, opportunitiesTags, recordType) => {
    const primaryTagID = opportunitiesTags.find(item => item.Tag === recordType)?.ID || 0;
    const primaryTagIDs = new Set(
        opportunitiesTags.filter(item => item.PrimaryCategory).map(item => item.ID)
    );
    const categoryStatuses = statuses.filter(status => getStatusTagIDs(status).includes(primaryTagID));
    const categorySubTagIDs = new Set(
        categoryStatuses.flatMap(status => (
            getStatusTagIDs(status).filter(tagID => !primaryTagIDs.has(tagID))
        ))
    );
    const salesTypes = opportunitiesTags
        .filter(item => categorySubTagIDs.has(item.ID))
        .sort((a, b) => a.Order - b.Order)
        .map(item => ({
            ...item,
            salesTypes: categoryStatuses.filter(status => getStatusTagIDs(status).includes(item.ID))
        }));

    return { salesTypes, selectedStatuses: categoryStatuses };
};
